<template>
	<div class="head">
		<div class="wrap">
			<div class="headbox">
				<img  :src="jiben.hlogoimage" class="logo"  @click="$router.push('/index')" style="cursor: pointer;" />
				<div class="navbox"> 
					<div :class="['navtxt',$store.state.headActive==1?'headActive':'']" @click="$router.push('/allsearchRefine/xmxqC')">项目需求池</div>
					<div :class="['navtxt',$store.state.headActive==2?'headActive':'']" @click="$router.push('/ResourceTools')">资源工具池</div>
					<div :class="['navtxt',$store.state.headActive==3?'headActive':'']"  @click="$router.push('/searchIndex/Solution')">解决方案池</div>
					<div :class="['navtxt',$store.state.headActive==4?'headActive':'']"  @click="$router.push('/proIndex/productService')">产品服务池</div>
					<div :class="['navtxt',$store.state.headActive==5?'headActive':'']" @click="$router.push('/geniusClub')">牛人俱乐部</div>
				</div>
				<div class="zhubox">
					<div v-if="$store.state.userInfo.login" style="display: flex;">
						<div class="zhutxt" @click="$router.push('/userCenter')" >
							个人中心
						</div>
						<div class="zhuline"></div>
						<div class="zhutxt" @click="logout">
							退出登录
						</div>
					</div>
					<div v-else style="display: flex;">
						<div class="zhutxt" @click="gotologin()">
							登录
						</div>
						<div class="zhuline"></div>
						<div class="zhutxt" @click="$router.push('/register')">
							注册
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState,mapActions,mapMutations} from "vuex";
	export default {
		name: 'headact',
		data() {
			return {
				active:0,
				jiben:[],
			}
		},
		async created() {
			await this.getJiben()  
		},  
		computed:{
			...mapState(['headActive'])
		},
		methods:{
			async getJiben() {
			    try {  
			        const response = await this.$api.getJiben();  
			        if (response && response.data) {  
			            this.jiben = response.data;  
			            console.log('基本信息', response.data);  
			        } else {  
			            console.error('获取基本信息失败，响应数据不完整', response);  
			        }  
			    } catch (error) {  
			        console.error('获取基本信息时发生错误', error);  
			    }  
			},
			checkTitle(active){
				this.$store.commit('SET_HeadActive',active)
				this.active = this.$store.state.headActive
			},
			logout(){
				sessionStorage.clear()
				this.$store.commit('SET_UserInfo',{})
				this.$router.replace('/login')
				console.log(window.history);
			},
			gotologin(){
				this.$router.push({ path: '/login' })
			 }
		}
	}
</script>

<style scoped>

</style>